import { render } from "./App.vue?vue&type=template&id=5dd05f67"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5dd05f67&lang=scss"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__